var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { generateId } from '../utils/idgen';
import { FilterSpec } from './UiTypesSpec';
import { Lexer } from './lexer';
import { parseGroup } from './parseGroup';
import { parseInput } from './parseInput';
import { parseModule, parseTheme, parseSiteMetadata as parseCommentSiteMetadata, } from './parseStructuredComment';
import { parseMetaDescription, parseMetaName } from './rs2fParser';
import { TokenType } from './token';
import { TokenStream } from './tokenstream';
var isModuleDeclaration = function (token) {
    return token.type === TokenType.COMMENT &&
        token.value.startsWith('/*@ define:module');
};
var isGroupDeclaration = function (token) {
    return token.type === TokenType.COMMENT &&
        token.value.startsWith('/*@ define:group');
};
var isInputDeclaration = function (token) {
    return token.type === TokenType.COMMENT &&
        token.value.startsWith('/*@ define:input');
};
var isThemeDeclaration = function (token) {
    return token.type === TokenType.COMMENT &&
        token.value.startsWith('/*@ define:theme');
};
var isSiteMetadataDeclaration = function (token) {
    return token.type === TokenType.COMMENT &&
        token.value.startsWith('/*@ define:sitemeta');
};
var parseStructuredComment = function (line) {
    var match = line.match(/\/\*@ define:([a-z]+):([a-z0-9_]+)/);
    if (!match) {
        throw new Error("Unparseable declaration at '".concat(line, "'"));
    }
    return {
        type: match[1],
        id: match[2],
    };
};
// the normal parse routine ignores sitemeta, that's handled explicitly here
// instead for backup restore
export var parseSiteMetadata = function (filter) {
    var tokens;
    try {
        tokens = new TokenStream(new Lexer(filter).tokenize());
    }
    catch (e) {
        return {
            errors: [{ line: '', error: e }],
        };
    }
    for (var _i = 0, _a = tokens.getTokens(); _i < _a.length; _i++) {
        var token = _a[_i];
        if (isSiteMetadataDeclaration(token)) {
            try {
                return { metadata: parseCommentSiteMetadata(token.value) };
            }
            catch (error) {
                return {
                    errors: [{ line: token.value, error: error }],
                };
            }
        }
    }
    return {};
};
export var parseModules = function (filter) {
    var _a;
    var result = parse(filter, false, { name: 'onlyModules' });
    return {
        errors: result.errors,
        modules: (_a = result.filter) === null || _a === void 0 ? void 0 : _a.modules,
    };
};
export var parse = function (filter, addHeaderModule, metaContentOverride) {
    if (addHeaderModule === void 0) { addHeaderModule = false; }
    var tokens;
    try {
        tokens = new TokenStream(new Lexer(filter).tokenize());
    }
    catch (e) {
        return {
            errors: [{ line: '', error: e }],
        };
    }
    if (!tokens.hasTokens()) {
        return {
            errors: [{ line: '', error: new Error('filter is blank') }],
        };
    }
    var first = tokens.peek();
    if (!isModuleDeclaration(first)) {
        // If the filter doesn't start with a module declaration, we need to add a header module
        // but ONLY if we're doing the migration from v2 to v3...
        if (addHeaderModule) {
            return parse("/*@ define:module:__migration_header__\nname: __migration_header__\nhidden: true\n*/\n" +
                filter, false);
        }
        return {
            errors: [
                {
                    line: first.value,
                    error: new Error('filter MUST start with a module declaration'),
                },
            ],
        };
    }
    var modulesById = {};
    var themesById = {};
    var errors = [];
    // we vetted the first token above, the loop will properly init this
    var currentModule = '';
    while (tokens.hasTokens()) {
        var next = tokens.take(true); // preserve whitespace in output
        try {
            if (isModuleDeclaration(next)) {
                var decl = parseStructuredComment(next.value);
                currentModule = decl.id;
                modulesById[decl.id] = parseModule(decl.id, next.value);
                modulesById[currentModule].rs2f += next.value;
            }
            else if (isSiteMetadataDeclaration(next)) {
                // Export metadata belongs to the file, never to a module.
                continue;
            }
            else if (isGroupDeclaration(next)) {
                var group = parseGroup(next.value);
                var module_1 = modulesById[currentModule];
                module_1.groups.push(group);
            }
            else if (isInputDeclaration(next)) {
                // define MUST come after the input declaration
                if (!tokens.hasTokens() ||
                    tokens.peek().type !== TokenType.PREPROC_DEFINE) {
                    throw new Error("missing define after block comment on line ".concat(next.location.line));
                }
                var define = new TokenStream(__spreadArray([
                    tokens.takeExpect(TokenType.PREPROC_DEFINE)
                ], tokens.takeLine().getTokens(), true));
                // capture source before parseInput consumes token stream
                var defineSource = define.toString();
                var input = parseInput(next.value, define);
                var module_2 = modulesById[currentModule];
                module_2.inputs.push(input);
                modulesById[currentModule].rs2f += next.value + '\n';
                modulesById[currentModule].rs2f += defineSource + '\n';
            }
            else if (isThemeDeclaration(next)) {
                var decl = parseStructuredComment(next.value);
                themesById[decl.id] = parseTheme(decl.id, next.value);
                // A theme doesn't _really_ belong to a module, but for serde to work we need it
                modulesById[currentModule].rs2f += next.value;
            }
            else {
                modulesById[currentModule].rs2f +=
                    next.type === TokenType.LITERAL_STRING
                        ? "\"".concat(next.value, "\"")
                        : next.value;
            }
        }
        catch (e) {
            errors.push({
                line: next.value,
                error: e,
            });
        }
    }
    if (errors.length > 0) {
        return {
            errors: errors,
            filter: undefined,
        };
    }
    var name = parseMetaName(filter);
    var description = parseMetaDescription(filter) || undefined;
    try {
        var parsedFilter = FilterSpec.parse(__assign({ id: generateId(), name: name, description: description, modules: Object.values(modulesById), importedOn: new Date().toISOString(), source: undefined, active: false, rs2f: filter, rs2fHash: '00000000', themes: Object.values(themesById) }, (metaContentOverride || {})));
        return {
            errors: undefined,
            filter: parsedFilter,
        };
    }
    catch (e) {
        return {
            errors: [
                {
                    line: filter,
                    error: new Error('Failed to parse filter - do you have a meta block?', {
                        cause: e,
                    }),
                },
            ],
            filter: undefined,
        };
    }
};
export var parseAsync = function (filterText, addHeaderModule) {
    if (addHeaderModule === void 0) { addHeaderModule = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    result = parse(filterText, addHeaderModule);
                    if (result.errors) {
                        return [2 /*return*/, Promise.resolve(result)];
                    }
                    _a = {};
                    return [4 /*yield*/, addRs2fHash(result.filter)];
                case 1: return [2 /*return*/, (_a.filter = _b.sent(), _a)];
            }
        });
    });
};
export var addRs2fHash = function (filter) { return __awaiter(void 0, void 0, void 0, function () {
    var filterBytes, hashBuffer, hashArray, rs2fHash;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                filterBytes = new TextEncoder().encode(filter.rs2f);
                return [4 /*yield*/, window.crypto.subtle.digest('SHA-1', filterBytes)];
            case 1:
                hashBuffer = _a.sent();
                hashArray = Array.from(new Uint8Array(hashBuffer));
                rs2fHash = hashArray
                    .map(function (b) { return b.toString(16).padStart(2, '0'); })
                    .join('');
                return [2 /*return*/, __assign(__assign({}, filter), { rs2fHash: rs2fHash })];
        }
    });
}); };
